/* eslint-disable */
import React, { useState, useRef } from "react";
import Input from "../../components/common/InputField";
import { useNavigate, useLocation } from 'react-router-dom';
import "./style.css";
import { Link } from "react-router-dom";
import validator from "validator";
import ButtonMain from "../../components/common/ButtonMain";
import clsx from "clsx";
import FailurePopup from '../../components/common/FailurePopup';
import { useSelector, useDispatch } from "react-redux";
import { emailDuplicationAPI } from "../../store/features/checkEmailDuplication";

export default function SignUpMain(props) {
  const location = useLocation();
  const takenEmail = location?.state?.takenEmail?.length > 0 ? location.state.takenEmail : '';
  const [emailFromSignUp, setEmailFromSignUp] = useState(takenEmail);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const navigate = useNavigate();
  const {
    setSelectedState,
    setSliderState,
    sliderState,
    SliderRegistration,
    setEmail,
    setFullName,
    email,
    fullName
  } = props;

  const fullNameInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  const [stateName, setStateMethod] = useState({
    email: email || takenEmail,
    emailInvalid: false,
    emailInvalidMessage: '',
    fullName: fullName || '',
    fullNameInvalidMessage: '',
    fullNameInvalid: false,
    FormSubmitting: false,
    nameState: !!fullName,
    emailState: !!email,
  });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showOkayButton, setShowOkayButton] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [titleOfPopup, setTitleOfPopup] = useState('');
  const [cancelButtonText, setCancelButtonText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const onCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  }
  const onCloseFailurePopup = () => {
    setShowFailurePopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  }

  const ValidateEmail = (email) => {
    if (validator.isEmail(email) === false) {
      return false;
    }
    return true;
  };
  const specialCharacterRegex = /[^a-zA-Z0-9 ]| {2,}|^[ ]|[ ]$/;
  const handleChange = (event) => {
    const { name, value } = event.target;

    setStateMethod((prev) => {
      let updated = { ...prev, [name]: value };

      // Clear error if field is empty
      if (!value.trim()) {
        if (name === "fullName") {
          updated.fullNameInvalidMessage = "";
          updated.fullNameInvalid = false;
          updated.nameState = false;
        }
        if (name === "email") {
          updated.emailInvalidMessage = "";
          updated.emailInvalid = false;
          updated.emailState = false;
        }
        return updated;
      }

      // Validate while fixing previous errors
      if (name === "fullName" && prev.fullNameInvalid) {
        if (value.trim().length < 3) {
          updated.fullNameInvalidMessage = t.FULLNAMEERROR;
          updated.fullNameInvalid = true;
          updated.nameState = false;
        } else if (specialCharacterRegex.test(value)) {
          updated.fullNameInvalidMessage = t.SPECIALCHARERROR;
          updated.fullNameInvalid = true;
          updated.nameState = false;
        } else {
          updated.fullNameInvalidMessage = "";
          updated.fullNameInvalid = false;
          updated.nameState = true;
        }
      }

      if (name === "email" && prev.emailInvalid) {
        if (!ValidateEmail(value)) {
          updated.emailInvalidMessage = t.EMAILERROR;
          updated.emailInvalid = true;
          updated.emailState = false;
        } else {
          updated.emailInvalidMessage = "";
          updated.emailInvalid = false;
          updated.emailState = true;
        }
      }

      return updated;
    });
  };


  // --- Validation Logic ---
  // Centralized validation runs only when submitHandler is called
  const validateFields = () => {
    let isValid = true;
    let updatedState = { ...stateName };

    // Full Name validation
    if (!stateName.fullName || stateName.fullName.trim().length < 3) {
      updatedState.fullNameInvalidMessage = t.FULLNAMEERROR;
      updatedState.fullNameInvalid = true;
      updatedState.nameState = false;
      isValid = false;
    } else if (stateName.fullName.trim().length > 24) {
      updatedState.fullNameInvalidMessage = 'Name cannot exceed 24 characters';
      updatedState.fullNameInvalid = true;
      updatedState.nameState = false;
      isValid = false;
    }
    else if (specialCharacterRegex.test(stateName.fullName)) {
      updatedState.fullNameInvalidMessage = t.SPECIALCHARERROR;
      updatedState.fullNameInvalid = true;
      updatedState.nameState = false;
      isValid = false;
    } else {
      updatedState.fullNameInvalidMessage = "";
      updatedState.fullNameInvalid = false;
      updatedState.nameState = true;
    }

    // Email validation
    if (!ValidateEmail(stateName.email)) {
      updatedState.emailInvalidMessage = t.EMAILERROR;
      updatedState.emailInvalid = true;
      updatedState.emailState = false;
      isValid = false;
    } else {
      updatedState.emailInvalidMessage = "";
      updatedState.emailInvalid = false;
      updatedState.emailState = true;
    }

    setStateMethod(updatedState);
    return isValid;
  };

  // --- submitHandler ---
  const submitHandler = async () => {
    const isValid = validateFields();

    if (isValid) {
      setIsLoading(true);
      const { email, fullName } = stateName;
      setEmail(email);
      setFullName(fullName);

      const checkEmailDuplicationDispatcher = dispatch(emailDuplicationAPI({ email }));
      checkEmailDuplicationDispatcher
        .then(async (data) => {
          if (typeof data.payload === "undefined") {
            setAlertMessage("Sorry, an error has occurred. Please try again. If the issue persists, please contact customer support.");
            setShowFailurePopup(true);
            setIsLoading(false);
          } else if (data?.payload?.success === true) {
            setSelectedState(1);
            setSliderState(1);
            setIsLoading(false);
          } else {
            setAlertMessage(
              `An account with this email already exists e.g. ${email}. Please retry with another email.`
            );
            setTitleOfPopup("Email Duplication Error");
            setShowFailurePopup(true);
            setShowCancelButton(true);
            setCancelButtonText("Login?");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setAlertMessage(error.message);
          setShowFailurePopup(true);
          setIsLoading(false);
        });
    }
  };

  const handleBlur = (event) => {
    switch (event.target.name) {
      case 'fullName':
        if (fullNameInputRef.current) {
          fullNameInputRef.current.classList.remove('input__error');
        }

        break;
      case 'email':
        if (emailInputRef.current) {
          emailInputRef.current.classList.remove('input-error');
        }

        break;
      default:
        break;
    }
  };
  const cancelButtonAction = async () => {
    await navigate('/login',
      {
        state: {
          takenEmail: stateName.email
        }
      });
  };
  return (
    <div className="SignUp-main-container">
      {/* Popups */}
      <FailurePopup
        cancelText={cancelButtonText}
        onCancel={cancelButtonAction}
        show={showFailurePopup}
        displayText={titleOfPopup}
        description={alertMessage}
        showOkayButton={showOkayButton}
        showCancelButton={showCancelButton}
        onOkay={onCloseFailurePopup} />
      {/* Popups */}
      <div className="slider-signup">
        <div className="inputDivStyle-signup">
          <p className="step__123">
            {`${t.STEP} 1`}
          </p>

          <div className="stepper__123">
            {SliderRegistration.map((stateValue) => (
              <p
                className={`underline__1 ${sliderState >= stateValue ? 'underline__1_active' : ''
                  }`}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="inputDivStyle-signup">
        <div className="textDiv">
          <p className="text__create">{t.CREATE_ACCOUNT}</p>
          <p className="text__start">{t.FREE_TRIAL_MSG}</p>
        </div>

        <Input
          type="text"
          id="fullName"
          name="fullName"
          title={t.TITLE_FULL_NAME}
          placeholder={t.PLACEHOLDER_FULL_NAME}
          value={stateName.fullName}
          onChange={(e) => handleChange(e)}
          onBlur={handleBlur}
          error={stateName.fullNameInvalidMessage}
          className={clsx(
            stateName.fullNameInvalid ? 'input__error' : ' ',
            stateName.nameState ? 'input__success' : ' ',
          )}
          ref={fullNameInputRef}
        />
        <br />
        <Input
          type="email"
          id="email"
          name="email"
          title={t.TITLE_EMAIL}
          placeholder={t.ENTR_EML_PH}
          value={stateName.email}
          onChange={(e) => handleChange(e)}
          error={stateName.emailInvalidMessage}
          className={clsx(
            stateName.emailInvalidMessage ? 'input__error' : '',
            stateName.emailState ? 'input__success' : ' ',
          )}
        />
        <div className="btn-class">
          <ButtonMain
            title={isLoading ? t.BTN_LOADING : t.BTN_CONTINUE}
            className={
              stateName.fullName?.trim() && stateName.email?.trim() && !isLoading
                ? "buttonStyleEnable"
                : "buttonStyleDisabled"
            }
            disabled={!(stateName.fullName?.trim() && stateName.email?.trim()) || isLoading}
            onClick={() => submitHandler()}
          />

          <p className="a__singIn">
            {t.ALREADY_ACC}
            <Link
              to="/login"
              style={{ textDecoration: 'none', paddingLeft: '5px' }}
            >
              <span className="b__signIn">{t.SIGNIN}</span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
